import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import RefreshIcon from '@material-ui/icons/Refresh';
import Sms from '@material-ui/icons/Sms';
import React, { useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import Chat from '../chat/Chat';
import { fetchMessagesJSON } from '../references';
import ChooseFile from './ChooseFile';




const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ChatFullScreenDialog(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openChooseImageDialog, setOpenChooseImageDialog] = useState(false);
  const [listMessage, setListMessage] = useState([]);
  const [userId, setUserId] = useState('');
  const [isImage, setIsImage] = useState(true);

  const notify=useNotify();

  useEffect(() => {
    setUserId(localStorage.getItem('user_id'));
    //fetchMessages();
    //console.log(props.idDetFact);

  },[]);

 const fetchMessages=()=>{
    fetchMessagesJSON(process.env.REACT_APP_URL+'/aerien/notes/'+props.idDetFact,'GET',null)
    .then((data) => {
      if(data && data.status>300){
        notify(data.message,'warning');    
      }else{
        setListMessage(data);
      }
    })
    .catch((e) => {
      notify(e,'warning');  
    });
 }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseChooseImageDialogFn = () => {
    setOpenChooseImageDialog(false);
  };

  const refreshMessageList = () => {
    fetchMessages();
  };

  const ajouteImage = (isImage) => {
    setIsImage(isImage);
    //console.log(openChooseImageDialog);
    //setUrl()
    setOpenChooseImageDialog(true);
    //alert("Photo");
  }

  return (
    <span >

      <ChooseFile idDetFact={props.idDetFact}  isImage={isImage} 
        openChooseImageDialogFn={handleCloseChooseImageDialogFn} 
        openChooseImageDialog={openChooseImageDialog}
        refreshMessageList={refreshMessageList}/>

      <Button onClick={()=>handleClickOpen()} color="primary" startIcon={<Sms />}>Chat</Button>
      <Dialog fullScreen open={open} onClose={()=>handleClose()} TransitionComponent={Transition} >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={()=>handleClose()} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {props.titreChat}
            </Typography>
            <Button onClick={()=>ajouteImage(true)}><PhotoCameraIcon/></Button>
            <Button onClick={()=>ajouteImage(false)}><PictureAsPdfIcon/></Button>
            <Button onClick={()=>refreshMessageList()}><RefreshIcon/></Button>
          </Toolbar>
        </AppBar>
        <Chat idDetFact={props.idDetFact} listMessage={listMessage} userId={userId} fetchMessages={fetchMessages} />
      </Dialog>
    </span>
  );
}
